import _Api from '@/api/_Api';

export default class TransfersApi extends _Api {
   static async getCostTransf(params: any): Promise<any> {
      const response = await this.http().get('transfers/get-cost-transfer', { params });
      return response.data;
   }
}
